<template>
    <!-- v-show="show" -->
    <div class="privacy-shade" :style="{display: show ? 'block' : 'none'}">
        <div class="shade-box"></div>
        <div class="shade-main">
            <div class="shade-main-title" :style="{color: mainColor}">个人信息保护声明</div>
            <div class="shade-main-content">
                <p>
                    保护用户个人信息是电动邦的一项基本原则。电动邦将按照本声明及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本声明对个人信息保护规定的内容与上述《隐私政策》有相冲突的，及本声明对个人信息保护相关内容未作明确规定的，以《隐私政策》的内容为准。
                </p>
                <dl>
                    <dt>一、个人信息的收集</dt>
                    <dd>1、我们收集您的个人信息的最终目的是为了向您提供更好的产品、服务，优化并丰富您的用户体验，我们仅收集与为您提供服务有关的信息，这些个人信息是能够单独或者与其他信息结合识别您的个人身份的信息，包括：
                    </dd>
                    <dd style="text-indent: 2em;">①姓名</dd>
                    <dd style="text-indent: 2em;">②移动电话</dd>
                    <dd style="text-indent: 2em;">③您在网站的表格上输入的其他信息（电子邮箱、车牌号、住址等）</dd>
                    <dd style="text-indent: 2em;">④在您上载到网站的内容中包含的任何个人信息</dd>
                    <dd>2、以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的产品、服务，或者可能对您使用产品或服务造成一定的影响。</dd>
                    <dd>3、对于不满18岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。</dd>
                </dl>
                <dl>
                    <dt>二、个人信息的使用和分享</dt>
                    <dd>您同意，电动邦可以通过以下方式对个人信息进行使用和分享（包含对于个人信息的存储和处理）：</dd>
                    <dd style="text-indent: 2em;">我们和关联公司使用；</dd>
                    <dd style="text-indent: 2em;">我们向相关汽车经销商、厂商及集团分享并由其在合法正当的范围内使用；</dd>
                    <dd style="text-indent: 2em;">我们及关联公司及相关汽车经销商、厂商、第三方服务商为满足您的需求，可能通过您提供的信息与您联系；</dd>
                    <dd style="text-indent: 2em;">我们及关联公司及相关汽车经销商、厂商、第三方服务商可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。</dd>
                    <dd>若我们拟将信息用于其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</dd>
                    <dd>您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。</dd>
                </dl>
                <dl>
                    <dt>三、更正或投诉</dt>
                    <dd>如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉</dd>
                    <dd>您可以拨打电话010-50953478联系我们</dd>
                </dl>
            </div>
            <div class="shade-main-close" @click.self="closePopover" :style="{backgroundColor: mainColor}">我知道了</div>
        </div>
	</div>
</template>
<script>
export default {
    name: 'Privacy',
    props: {
        show: Boolean,
        privacyColor: {
            type: String,
            value: '#223244'
        }
    },
    emits: ["upload:show"],
    data(){
        return {
            mainColor: this.privacyColor
        }
    },
    watch: {
        privacyColor: function(newVal) {
            this.mainColor = newVal;
        },
        show: function(newVal){
            console.log('privacy', newVal)
        }
    },
    created(){
    },
    mounted(){
    },
    methods: {
        closePopover(){
            this.$emit('togglePrivacyPopover', false)
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.privacy-shade{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(0,0,0,0.5);
}
.shade-box{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}
.shade-main{
    width: 600px;/*50%;*/
    height: auto;
    position: absolute;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 2;
    border-radius: 15px 15px 0 0;
}
.shade-main-close{
    position: absolute;
    width: 100%;
    height: 80px;
    line-height: 80px;
    color: #fff;
    background: #223244;
    font-size: 28px;
    bottom: 0;
    left: 0;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
}
.shade-main-title{
    line-height: 2;
    height: auto;
    text-align: center;
    color: #223244;
    font-size: 34px;
    text-align: center;
    font-weight: bold;
    padding: 40px 0 15px 0;
    box-sizing: content-box;
}
.shade-main-content{
    position: relative;
    height: calc(100% - 100px - 80px);
    padding: 0 30px 30px 30px;
    overflow: auto;
    color: #424242;
    overflow-y: auto;
    text-align: left;
}
.shade-main-content p {
    font-size: 24px;
    line-height: 1.6;
    margin-bottom: 24px;
    text-indent: 2em;
}
.shade-main-content dl {
    margin-bottom: 24px;
}
.shade-main-content dt {
    font-size: 27px;
    line-height: 1.45;
    margin-bottom: 4px;
}
.shade-main-content dd {
    font-size: 18px;
    line-height: 1.7;
}
</style>
